(() => {
  if (customElements.get('net-wishlist-toggle')) return;
  const key = 'wishListsArr';
  const read = () => {
    const items = JSON.parse(localStorage.getItem(key) || '[]');
    if (!Array.isArray(items) || items.some(item => typeof item !== 'string' || !item)) throw new Error('storage');
    return [...new Set(items)];
  };
  class WishlistToggle extends HTMLElement {
    connectedCallback() {
      this.controller?.abort();
      this.controller = new AbortController();
      const options = { signal: this.controller.signal };
      const button = this.querySelector('button');
      if (!button) return;
      const sync = () => {
        try {
          const saved = read().includes(this.dataset.handle);
          button.setAttribute('aria-pressed', String(saved));
          button.setAttribute('aria-label', saved ? button.dataset.remove : button.dataset.add);
          button.title = button.getAttribute('aria-label');
        } catch (_) { }
      };
      this.addEventListener('click', event => {
        if (!event.target.closest('button')) return;
        event.preventDefault();
        event.stopPropagation();
        try {
          const items = read();
          const handle = this.dataset.handle;
          const next = items.includes(handle) ? items.filter(item => item !== handle) : [...items, handle];
          localStorage.setItem(key, JSON.stringify(next));
          this.querySelector('[role=status]').textContent = '';
          document.dispatchEvent(new CustomEvent('net:wishlist-change'));
        } catch (_) {
          this.querySelector('[role=status]').textContent = button.dataset.error;
        }
      }, options);
      document.addEventListener('net:wishlist-change', sync, options);
      window.addEventListener('storage', event => {
        if (event.key === key || event.key === null) sync();
      }, options);
      sync();
    }
    disconnectedCallback() { this.controller?.abort(); }
  }
  customElements.define('net-wishlist-toggle', WishlistToggle);
})();
